@if (payment.fiscal_operation; as operation) {
  <div class="flex min-w-40 max-w-72 flex-col items-start gap-1.5 text-xs leading-normal">
    <div class="flex items-center gap-2">
      <span>{{ 'prro.task.' + operation.task | translate }}</span>
      <app-tag
        [tag]="{
          id: operation.status,
          name: ('prro.status.' + operation.status | translate),
          color:
            operation.status === 'succeeded'
              ? '#047857'
              : operation.status === 'manual_required'
                ? '#b91c1c'
                : '#64748b',
        }"
        [maxCharacters]="100"
        [icon]="
          operation.status === 'succeeded' ? 'check_circle' : operation.status === 'manual_required' ? 'error' : 'info'
        "
      />
      @if (operation.receipt_url) {
        <a
          class="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded !text-orange-700 !no-underline hover:bg-orange-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-orange-500"
          [href]="operation.receipt_url"
          [title]="operation.fiscal_receipt_number || ('prro.receipt_link' | translate)"
          [attr.aria-label]="'prro.receipt_link' | translate"
          target="_blank"
          rel="noopener noreferrer"
        >
          <app-icon class="!flex !h-[18px] !w-[18px] !text-[18px] !leading-none">receipt_long</app-icon>
        </a>
      }
    </div>
    @if (operation.error) {
      <p
        class="!m-0 break-words"
        [ngClass]="operation.error['code'] === 'FISCAL_RECEIPT_SHIFT_PENDING' ? 'text-slate-500' : 'text-red-700'"
      >
        {{ fiscalNotifications.errorMessage(operation.error) }}
      </p>
    }
    @if (operation.warnings?.length) {
      <span class="text-amber-700" [title]="operation.warnings | json">{{ 'prro.warnings' | translate }}</span>
    }
    @if (canRetry(operation)) {
      <app-button btnType="stroked" [disabled]="busy" (onChangeClick)="retry()">{{
        'prro.retry' | translate
      }}</app-button>
    }
    @if (payment.x_data?.receipt_delivery; as delivery) {
      <span class="mt-1 text-slate-500">{{ 'prro.delivery.' + delivery.status | translate }}</span>
      @if (delivery.error) {
        <span class="text-red-700">{{ 'prro.delivery_failed' | translate }}</span>
      }
      @if (delivery.status === 'failed') {
        <app-button btnType="stroked" [disabled]="busy" (onChangeClick)="retry(true)">{{
          'prro.retry_delivery' | translate
        }}</app-button>
      }
    }
    @if (refunded > 0) {
      <span class="block text-xs text-orange-700"
        >{{ 'prro.refund.refunded' | translate }}: {{ refunded | currency: 'UAH' : 'symbol-narrow' : '1.2-2' }}</span
      >
    }
  </div>
} @else {
  <span class="text-slate-300">—</span>
}
